import { FC } from 'react'
import { isOrderCompleted, isOrderShipped } from '@/network/models/order'
import { OrderStatusId } from '@/network/graphql.g'
import DetailStatusBanner, {
  DetailStatusSuccessIcon,
  DetailStatusWaitingIcon
} from '@/components/molecules/detailStatusBanner'

type OrderStatusBannerProps = {
  status: string
  statusId: OrderStatusId
  statusColor: string
} & Rest

const OrderStatusBanner: FC<OrderStatusBannerProps> = ({
  status,
  statusId,
  statusColor,
  ...rest
}) => (
  <DetailStatusBanner
    status={status}
    statusColor={statusColor}
    icon={
      isOrderShipped(statusId) || isOrderCompleted(statusId) ? (
        <DetailStatusSuccessIcon statusColor={statusColor} />
      ) : (
        <DetailStatusWaitingIcon statusColor={statusColor} />
      )
    }
    {...rest}
  />
)

export default OrderStatusBanner
